(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // TAB SWITCHING
const tabs = document.querySelectorAll(".TabSliderMenu");
const contents = document.querySelectorAll(".MenuContentBox");
const imageBlocks = document.querySelectorAll(".mobile-menu-block");

tabs.forEach(tab => {
  tab.addEventListener("click", function () {
    const index = this.dataset.index;
    tabs.forEach(t => t.classList.remove("TabActive"));
    this.classList.add("TabActive");
    contents.forEach(c => c.style.display = "none");
    const activeContent = document.querySelector(`.MenuContentBox[data-content="${index}"]`);
    if (activeContent) activeContent.style.display = "block";
    imageBlocks.forEach(img => img.style.display = "none");
    const activeImage = document.querySelector(`.mobile-menu-block[data-content="${index}"]`);
    if (activeImage) activeImage.style.display = "block";
  });
});

document.querySelectorAll(".AccordionHeader").forEach(header => {
  header.addEventListener("click", function () {
    const grandChild = this.nextElementSibling; 
    grandChild.classList.toggle("open");
    this.classList.toggle("open");
  });
});
  } catch(e) { console.error(e); }
})();

})();
